/* REDCAMP: decorate Judge.me's own nodes. Do not move/clone media or alter click handlers. */
(() => {
  'use strict';
  const rootSelector = '#judgeme_product_reviews';
  const roles = ['rc-jm-grid-title','rc-jm-grid-chart','rc-jm-grid-score','rc-jm-grid-action','rc-jm-grid-gallery','rc-jm-grid-badges','rc-jm-score-number','rc-jm-review-count','rc-jm-gallery-items'];
  const within = (el, branch) => !!branch && (el === branch || branch.contains(el));
  const crosses = (el, branch) => within(el, branch) || within(branch, el);

  function findGallery(header, ignored) {
    const isSeparate = el => !!el && el !== header && !ignored.some(node => crosses(el, node));
    const explicit = Array.from(header.querySelectorAll([
      '[class*="media-gallery"]','[class*="review-gallery"]','[class*="photo-gallery"]',
      '[class*="media-carousel"]','[class*="review-photos"]','[class*="media-strip"]',
      '[class*="media-preview"]'
    ].join(','))).filter(isSeparate);
    if (explicit.length) {
      // Pick a gallery container, rather than an individual media tile.
      explicit.sort((a,b) => b.querySelectorAll('img,video').length - a.querySelectorAll('img,video').length);
      return explicit[0];
    }
    // Some 2026 widget variants have different CSS class names.
    const pictures = Array.from(header.querySelectorAll('img,video')).filter(el =>
      !ignored.some(node => crosses(el,node)) &&
      !el.closest('[class*="badge"],[class*="medal"],[class*="authentic"],[class*="transparency"]')
    );
    if (pictures.length < 3) return null;
    let candidate = pictures[0].parentElement;
    while (candidate && candidate !== header) {
      if (pictures.filter(pic => candidate.contains(pic)).length >= 3 && isSeparate(candidate)) return candidate;
      candidate = candidate.parentElement;
    }
    return null;
  }

  function findScore(header, ignored) {
    const excluded = el => ignored.some(n => crosses(el, n));
    const elements = Array.from(header.querySelectorAll('div,span,p,strong,b'));
    const avg = /\b[0-5](?:[.,]\d{1,2})\b/;
    const reviews = /\b\d+\s*reviews?\b/i;
    const candidates = elements.filter(el => {
      if (excluded(el)) return false;
      const t = (el.innerText || el.textContent || '').trim().replace(/\s+/g,' ');
      return t.length < 120 && avg.test(t) && reviews.test(t);
    }).sort((a,b) => a.querySelectorAll('*').length - b.querySelectorAll('*').length);
    return candidates[0] || null;
  }

  function apply(widget) {
    const header = widget.querySelector('.jm-review-widget-header');
    if (!header) return;
    const title = header.querySelector('.jm-review-widget-header__title');
    const chart = header.querySelector('.jm-review-widget-header__star-rating-histogram');
    const action = header.querySelector('.jm-action-buttons');
    if (!title || !chart || !action) return;
    const score = findScore(header, [title, chart, action]);
    if (!score) return;
    const gallery = findGallery(header, [title, chart, action, score]);
    const badges = Array.from(header.querySelectorAll(
      '[class*="transparency-badge"],[class*="authenticity-badge"],[class*="trust-badge"],[class*="medals"]'
    )).find(el => ![title, chart, action, score, gallery].some(n => crosses(el,n)));
    if (header.classList.contains('rc-jm-coleman') &&
        title.classList.contains('rc-jm-grid-title') &&
        (!gallery || gallery.classList.contains('rc-jm-grid-gallery'))) return;

    header.querySelectorAll(roles.map(n => '.' + n).join(',')).forEach(el =>
      roles.forEach(cls => el.classList.remove(cls)));
    header.querySelectorAll('.rc-jm-grid-pass').forEach(el => el.classList.remove('rc-jm-grid-pass'));
    const items = [[title,'rc-jm-grid-title'],[chart,'rc-jm-grid-chart'],[score,'rc-jm-grid-score'],
                   [action,'rc-jm-grid-action'],[gallery,'rc-jm-grid-gallery'],[badges,'rc-jm-grid-badges']];
    items.forEach(([el,cls]) => {
      if (!el) return;
      el.classList.add(cls);
      for (let parent=el.parentElement; parent && parent!==header; parent=parent.parentElement)
        parent.classList.add('rc-jm-grid-pass');
    });
    // Find the existing thumbnail strip and only change how its items wrap.
    if (gallery) {
      const options = [gallery, ...gallery.querySelectorAll('div,ul,ol')];
      const strip = options.find(el =>
        Array.from(el.children).filter(child => child.matches('img,video') || child.querySelector('img,video')).length >= 3
      );
      if (strip) strip.classList.add('rc-jm-gallery-items');
    }
    // Style the existing rating text without changing its content or events.
    Array.from(score.querySelectorAll('span,strong,b,div')).forEach(el => {
      if (el.children.length) return;
      const t = (el.textContent || '').trim();
      if (/^[0-5](?:[.,]\d{1,2})$/.test(t)) el.classList.add('rc-jm-score-number');
      if (/^\d+\s*reviews?$/i.test(t)) el.classList.add('rc-jm-review-count');
    });
    header.classList.add('rc-jm-coleman');
  }

  const scan = () => document.querySelectorAll(rootSelector).forEach(apply);
  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; scan(); });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, {once:true});
  else schedule();
  new MutationObserver(records => {
    if (records.some(r => r.addedNodes.length || r.removedNodes.length)) schedule();
  }).observe(document.documentElement, {childList:true,subtree:true});
})();

/* V4: layout polish for Judge.me's own AI insights and review toolbar. */
(() => {
  'use strict';
  const selector = '#judgeme_product_reviews';
  const simpleText = el => (el.textContent || '').trim().replace(/\s+/g, ' ');
  const leaves = (root, exact) => Array.from(root.querySelectorAll('span,p,h2,h3,h4,h5,h6,strong,b,div'))
    .find(el => simpleText(el) === exact && !Array.from(el.children).some(c => simpleText(c) === exact));

  function findInsights(widget) {
    // Do not relabel descendants after AI panels have been separated.
    const completed = widget.querySelector('.rc-jm-insights-panel[data-rc-ai-split="1"]');
    if (completed) return completed;
    const title = leaves(widget, 'Customers say');
    if (!title) return null;
    const highlights = leaves(widget, 'Review highlights');
    let panel = title.parentElement;
    if (highlights) {
      while (panel && panel !== widget && !panel.contains(highlights)) panel = panel.parentElement;
    } else {
      // A short review-summary-only variant has no highlights.
      while (panel && panel !== widget && simpleText(panel).length < 120) panel = panel.parentElement;
    }
    if (!panel || panel === widget || panel.querySelector('.jm-review-item')) return null;
    panel.classList.add('rc-jm-insights-panel');
    title.classList.add('rc-jm-insights-title');
    if (highlights && panel.contains(highlights)) highlights.classList.add('rc-jm-insights-subheading');
    const copies = Array.from(panel.querySelectorAll('.jm-text,p,span,div'))
      .filter(el => el !== title && !el.contains(title) &&
        el.children.length === 0 && simpleText(el).length > 100);
    // Only the paragraph-sized review summary gets the larger body type.
    if (copies.length) copies.sort((a,b) => simpleText(b).length - simpleText(a).length)[0]
      .classList.add('rc-jm-insights-copy');
    return panel;
  }

  function findTools(widget) {
    const input = widget.querySelector('input[type="search"],input[placeholder*="Search" i],[role="searchbox"]');
    if (!input) return null;
    for (let p = input.parentElement; p && p !== widget; p = p.parentElement) {
      if (p.querySelector('.jm-review-item')) return null;
      const controls = Array.from(p.querySelectorAll('button,[role="button"],select'));
      if (controls.length >= 2 && controls.some(el => /filter|sort|most/i.test(el.getAttribute('aria-label') || simpleText(el)))) {
        return p;
      }
    }
    return null;
  }

  function scan() {
    document.querySelectorAll(selector).forEach(widget => {
      const summary = findInsights(widget);
      const tools = findTools(widget);
      if (!summary || !tools || summary.contains(tools) || tools.contains(summary)) return;
      tools.classList.add('rc-jm-review-tools');
      tools.style.setProperty('--rc-jm-tools-shift', '0px');
      if (window.innerWidth <= 900) return;
      const outerRight = Math.min(widget.getBoundingClientRect().right, window.innerWidth - 16);
      const toolsRect = tools.getBoundingClientRect();
      const summaryRect = summary.getBoundingClientRect();
      // Prevent the controls from overlapping the summary at narrower widths.
      const shift = Math.max(0, outerRight - toolsRect.right);
      if (toolsRect.left + shift >= summaryRect.right + 16) {
        tools.style.setProperty('--rc-jm-tools-shift', `${Math.round(shift)}px`);
      }
    });
  }
  let pending = false;
  const queue = () => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; scan(); });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', queue, {once:true});
  else queue();
  new MutationObserver(records => {
    if (records.some(r => r.addedNodes.length || r.removedNodes.length)) queue();
  }).observe(document.documentElement, {childList:true,subtree:true});
  window.addEventListener('resize', queue, {passive:true});
})();


/* V5: assign existing Judge.me insights/controls to their layout cells.
   Rating and review counts are always read from Judge.me's rendered content.
   Native photos, links, buttons and their event handlers are untouched. */
(() => {
  'use strict';
  function refresh() {
    document.querySelectorAll('#judgeme_product_reviews').forEach(widget => {
      const header = widget.querySelector('.jm-review-widget-header.rc-jm-coleman');
      if (!header) return;
      const score = header.querySelector('.rc-jm-grid-score');
      const value = score && score.querySelector('.rc-jm-score-number');
      if (value) {
        const match = (value.textContent || '').trim().match(/^([0-5](?:[.,]\d{1,2})?)$/);
        if (match) {
          const rating = Math.max(0, Math.min(5, Number(match[1].replace(',', '.'))));
          value.style.setProperty('--rc-jm-star-fill', `${rating / 5 * 100}%`);
        }
      }
      [
        [widget.querySelector('.rc-jm-insights-panel'), 'rc-jm-grid-insights'],
        [widget.querySelector('.rc-jm-review-tools'), 'rc-jm-grid-review-tools']
      ].forEach(([el, role]) => {
        if (!el || !header.contains(el)) return;
        el.classList.add(role);
        el.classList.remove('rc-jm-grid-pass');
        for (let p = el.parentElement; p && p !== header; p = p.parentElement) {
          p.classList.add('rc-jm-grid-pass');
        }
      });
    });
  }
  let pending = false;
  function queue() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => {pending = false; refresh();});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',queue,{once:true});
  else queue();
  new MutationObserver(records => {
    if (records.some(r => r.addedNodes.length || r.removedNodes.length)) queue();
  }).observe(document.documentElement, {childList:true,subtree:true});
})();

/* V8. Separate only the two AI content groups; do not touch other Judge.me controls. */
(() => {
  'use strict';
  const norm = e => (e?.textContent || '').trim().replace(/\s+/g, ' ');
  const leaf = (scope, value) => Array.from(scope.querySelectorAll('h2,h3,h4,h5,h6,span,strong,b,p,div'))
    .find(el => norm(el) === value && !Array.from(el.children).some(c => norm(c) === value));
  const directChildOf = (parent, el) => {
    while (el && el.parentElement !== parent) el = el.parentElement;
    return el?.parentElement === parent ? el : null;
  };
  function split(panel) {
    if (!panel || panel.dataset.rcAiSplit === '1' || panel.closest('.rc-jm-ai-wrap')) return;
    const l = leaf(panel, 'Customers say');
    const r = leaf(panel, 'Review highlights');
    if (!l || !r) return;
    // Avoid changing any Judge.me controls or review card tree.
    if (panel.querySelector('.jm-review-item,.jm-review-widget-header__title,.jm-action-buttons,input[type="search"],.jm-review-widget-header__star-rating-histogram')) return;
    const leftChild = directChildOf(panel,l);
    const rightChild = directChildOf(panel,r);
    if (!leftChild || !rightChild || leftChild === rightChild) return;
    const nodes = Array.from(panel.children);
    const li = nodes.indexOf(leftChild), ri = nodes.indexOf(rightChild);
    if (li<0 || ri<=li) return;
    if (nodes.length>20) return;
    // Mark before any tree changes. Prevent repeated wrapping on later renders.
    panel.dataset.rcAiSplit = '1';
    const wrap = document.createElement('div');
    wrap.className = 'rc-jm-ai-wrap';
    const left = document.createElement('div');
    left.className = 'rc-jm-ai-box rc-jm-ai-box-left';
    const right = document.createElement('div');
    right.className = 'rc-jm-ai-box rc-jm-ai-box-right';
    nodes.slice(li,ri).forEach(node=>left.appendChild(node));
    nodes.slice(ri).forEach(node=>right.appendChild(node));
    wrap.append(left,right);
    panel.appendChild(wrap);
  }
  let scheduled=false;
  function schedule(){
    if (scheduled) return;
    scheduled=true;
    requestAnimationFrame(()=>{
      scheduled=false;
      document.querySelectorAll('#judgeme_product_reviews .rc-jm-insights-panel').forEach(split);
    });
  }
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',schedule,{once:true});
  else schedule();
  new MutationObserver(records=>{
    if(records.some(r=>r.addedNodes.length || r.removedNodes.length)) schedule();
  }).observe(document.documentElement,{childList:true,subtree:true});
})();


/* REDCAMP V10: connected-pointer filter dropdown; native Judge.me options remain intact. */
(() => {
  'use strict';
  const ROOT = '#judgeme_product_reviews';
  const states = new WeakMap();
  const label = node => (node?.textContent || '').trim().replace(/\s+/g, ' ');
  const exact = (node, word) => label(node) === word &&
    !Array.from(node.children).some(child => label(child) === word);

  function locatePanel(widget, button) {
    const tagged = widget.querySelector('.rc-jm-native-filter-popover');
    if (tagged && !tagged.contains(button)) return tagged;
    const nodes = Array.from(widget.querySelectorAll('span,p,div,label,h3,h4,h5'));
    const rating = nodes.filter(n => exact(n, 'Rating'));
    const keywords = nodes.filter(n => exact(n, 'Keyword'));
    const headings = nodes.filter(n => exact(n, 'Filters'));
    for (const r of rating) {
      for (const k of keywords) {
        for (let p = r.parentElement; p && p !== widget; p = p.parentElement) {
          if (!p.contains(k) || p.contains(button)) continue;
          const content = label(p);
          if (/customers say|review highlights|rating snapshot|write a review/i.test(content)) break;
          if (!headings.some(h => p.contains(h))) continue;
          if (p.querySelector('.jm-review-item')) break;
          p.classList.add('rc-jm-native-filter-popover');
          return p;
        }
      }
    }
    return null;
  }

  function align(state) {
    if (!state.open || !state.button.isConnected || !state.panel?.isConnected) return;
    const trigger = state.button.getBoundingClientRect();
    if (!trigger.width || !trigger.height) return;
    const panel = state.panel;
    const width = Math.min(320, window.innerWidth - 24);
    const height = Math.min(panel.scrollHeight || 285, 460, Math.floor(window.innerHeight * .7));
    const x = Math.max(12, Math.min(window.innerWidth - width - 12, trigger.right - width));
    // The menu touches the button edge: pointer can travel directly into it.
    const below = trigger.bottom - 1;
    const above = trigger.top - height + 1;
    const top = (below + height <= window.innerHeight - 8 || above < 8) ? below : above;
    panel.style.setProperty('--rc-filter-x', Math.round(x) + 'px');
    panel.style.setProperty('--rc-filter-y', Math.round(top) + 'px');
  }

  function cancelClose(state) {
    if (state.timer) clearTimeout(state.timer);
    state.timer = null;
  }
  function setOpen(state, open) {
    cancelClose(state);
    state.open = open;
    if (!open) state.hasDirectClick = false;
    state.panel = locatePanel(state.widget, state.button);
    if (state.panel) {
      state.panel.classList.toggle('rc-jm-filter-open', open);
      if (open) align(state);
      bindPanel(state);
    }
    state.button.classList.toggle('rc-jm-filter-trigger-active', open);
    state.button.setAttribute('aria-expanded', String(open));
  }
  function scheduleClose(state) {
    cancelClose(state);
    state.timer = setTimeout(() => {
      const target = document.elementFromPoint(state.pointerX, state.pointerY);
      if (target && (state.button.contains(target) || state.panel?.contains(target))) return;
      setOpen(state, false);
    }, 280);
  }
  function bindPanel(state) {
    const panel = state.panel;
    if (!panel || panel.dataset.rcFilterHandlers === '1') return;
    panel.dataset.rcFilterHandlers = '1';
    panel.addEventListener('pointerenter', e => {
      if (e.pointerType === 'mouse') cancelClose(state);
    });
    panel.addEventListener('pointerleave', e => {
      if (e.pointerType === 'mouse') scheduleClose(state);
    });
  }
  function openWithNativeFallback(state) {
    state.panel = locatePanel(state.widget, state.button);
    if (!state.panel && !state.mountRequested) {
      // Some Judge.me versions mount the filters only after their own click.
      state.mountRequested = true;
      state.button.click();
      requestAnimationFrame(() => {
        state.mountRequested = false;
        if (state.open) setOpen(state, true);
      });
    }
    setOpen(state, true);
  }
  function install(widget) {
    const toolbar = widget.querySelector('.rc-jm-grid-review-tools');
    if (!toolbar) return;
    const buttons = Array.from(toolbar.querySelectorAll('button,[role="button"]'));
    const button = buttons.find(n => /\bFilters?\b/i.test(`${n.getAttribute('aria-label') || ''} ${label(n)}`));
    const sort = buttons.find(n => /most|sort|recent|newest|oldest|relevant/i
      .test(`${n.getAttribute('aria-label') || ''} ${label(n)}`) && n !== button);
    if (sort) sort.classList.add('rc-jm-sort-trigger');
    if (!button) return;

    let state = states.get(widget);
    if (!state || state.button !== button) {
      if (state) cancelClose(state);
      state = {widget,button,panel:null,timer:null,open:false,hasDirectClick:false,pointerX:-1,pointerY:-1,mountRequested:false};
      states.set(widget,state);
      button.addEventListener('pointerenter', e => {
        if (e.pointerType === 'mouse') openWithNativeFallback(state);
      });
      button.addEventListener('pointerleave', e => {
        if (e.pointerType === 'mouse') scheduleClose(state);
      });
      // Once Judge.me has mounted its own filter options, keep them mounted.
      // Handle the trigger only; Judge.me keeps all option click handlers.
      button.addEventListener('click', e => {
        if (state.mountRequested) return;
        state.panel = locatePanel(widget, button);
        if (state.panel) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
        }
        const next = !state.hasDirectClick || !state.open;
        state.hasDirectClick = true;
        setOpen(state, next);
        if (!state.panel && next) {
          requestAnimationFrame(() => setOpen(state, true));
        }
      }, true);
      button.addEventListener('focus', () => {
        if (!state.open) openWithNativeFallback(state);
      });
    }
    state.panel = locatePanel(widget, button);
    if (state.panel) {
      state.panel.classList.toggle('rc-jm-filter-open', state.open);
      bindPanel(state);
      if (state.open) align(state);
    }
  }

  let queued = false;
  function refresh() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      document.querySelectorAll(ROOT).forEach(install);
    });
  }
  document.addEventListener('pointermove', e => {
    if (e.pointerType !== 'mouse') return;
    document.querySelectorAll(ROOT).forEach(widget => {
      const state = states.get(widget);
      if (state && state.open) {state.pointerX = e.clientX;state.pointerY = e.clientY;}
    });
  }, {passive:true});
  document.addEventListener('pointerdown', e => {
    document.querySelectorAll(ROOT).forEach(widget => {
      const state = states.get(widget);
      if (state?.open && !state.button.contains(e.target) && !state.panel?.contains(e.target))
        setOpen(state, false);
    });
  }, true);
  document.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    document.querySelectorAll(ROOT).forEach(widget => {
      const state = states.get(widget);
      if (state?.open) setOpen(state, false);
    });
  });
  window.addEventListener('scroll', () => {
    document.querySelectorAll(ROOT).forEach(widget => {
      const state = states.get(widget); if (state?.open) align(state);
    });
  }, {passive:true, capture:true});
  window.addEventListener('resize', refresh, {passive:true});
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, {once:true});
  else refresh();
  new MutationObserver(changes => {
    if (changes.some(x => x.addedNodes.length || x.removedNodes.length)) refresh();
  }).observe(document.documentElement,{childList:true,subtree:true});
})();
